import { gql } from "@apollo/client";
export default gql`
  mutation UpdateHospitalMfa($input: HospitalMfaInputs!) {
    updateHospitalMfa(input: $input)
  }
`;
